export function migrateParticipantsPagePersistedState<
  T extends { view?: string },
>(persisted: T): T {
  if (persisted.view !== 'day-center') {
    return persisted
  }
  return { ...persisted, view: 'day-center-am' }
}
